import React, { FC, useState } from "react";
import classNames from "classnames/dedupe";
import { ILink, Link } from "../../ActionsSelectors";
import { ExitCrossIcon } from "../../../icons";

export interface IPromoLine {
  /** Title */
  title: string;
  /** Link */
  link: ILink;
  /** Text that has underline */
  highlight?: string;
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    /**
     * applied to outer 'div' element
     */
    root?: string;
  };
  type?: "primary" | "secondary" | "error" | "golden";
}

const PromoLine: FC<IPromoLine> = ({
  title,
  link,
  highlight,
  classes,
  type,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleCloseButton = (e) => {
    e.preventDefault();
    setIsOpen(false);
  };

  const rootClasses = classNames(
    classes?.root,
    "container-fluid d-flex align-items-center text-color-white mt-4 min-h-4 py-4 text-decoration-none cursor-pointer",
    {
      "d-none": !isOpen,
      "bg-color-red": !type || type === "secondary",
      "bg-color-blue": type === "primary",
      "bg-color-golden": type === "golden",
    },
  );

  return (
    <Link
      {...link}
      classes={{ root: rootClasses }}
      style={{
        minHeight: "48px",
      }}
      data-testid="PromoLine__root"
    >
      <>
        <span className="ms-auto">
          {title}
          <span>&nbsp;</span>
          {highlight && (
            <span className="text-decoration-underline">{highlight}</span>
          )}
        </span>
        <ExitCrossIcon
          className="ms-auto"
          data-testid="PromoLine__closeButton"
          onClick={(e) => handleCloseButton(e)}
        />
      </>
    </Link>
  );
};

export default PromoLine;
